module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"details":"Edit","remove":"Delete","success":"Successfully deleted"}}')
  delete Component.options._Ctor
}
